module.exports = __webpack_public_path__ + "img/53.64b134a3.jpg";